import useAppBootstrap from '@/hooks/useAppBootstrap';
import AppShell from '../AppShell';
import type { AppContentProps } from './types';

/**
 * Top-level composition. All boot-time effects live behind useAppBootstrap;
 * all rendering lives in AppShell. The split keeps each layer focused on
 * one concern and makes the boot path independently testable.
 */
const AppContent = ({ showHeader, hideTrending }: AppContentProps) => {
  const { isPending } = useAppBootstrap();

  if (isPending) return null;

  return <AppShell showHeader={showHeader} hideTrending={hideTrending} />;
};

export default AppContent;
